import { Directive, ElementRef, Output, HostListener, EventEmitter } from '@angular/core';
@Directive({
   selector: '[mediaLoad]'
})
export class MediaLoadDirective {
   constructor(private el: ElementRef) { }   
   
   @Output('mediaLoad') mediaLoad: EventEmitter<any> = new EventEmitter();

   @HostListener('loadeddata', ['$event']) 
   onLoadVideo(e){
      this.mediaLoad.emit(e);
   }

   @HostListener('load', ['$event']) 
   onLoadImage(e){
      this.mediaLoad.emit(e);
   }

   @HostListener('error', ['$event']) 
   onError(e){
      this.mediaLoad.emit(e);
   }
}